var default_addToCartText = "Add To Bag";
var default_addedToCartText = "Added to Bag!";
var default_add_all_to_cart_text = "Add All To Bag"
var out_of_stock_text = "Out of Stock";
var no_products_found_text ="No products found. Please retry!";

// Map variable to store add all to cart links for each sections
var sections_add_to_cart_map={};
var tangent_client_domain_currency;

// Tab title mapping based on tags
var tabs_title_mapping={
  section_basic:"Basic",
  section_skinsentials:"Skinsentials",
  section_supercharged:"Supercharged"
}

// Add default image url here
var tangent_default_selfie_image_url="https://cdn.shopify.com/s/files/1/0665/2405/3719/files/Coats_Skinsentials_Still_Life_Bathroom_1.jpg?v=1720525580";
var default_variant_image_url ="https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp"

var tangent_custom_tabs = document.querySelector("#tangent_custom_tabs");
var tangent_client_domain_url = window.location.origin;
var tangent_sections_wrapper_element = document.querySelector("#tangent_sections_wrapper"); 


window.onload = function() {
    var tangent_response_id = getClientResponseId()
    checkoutDataApiCall(tangent_response_id);
}

function getClientResponseId(){
  // Current Page Load URL
  var tangent_client_url = new URL(window.location.href);
  return tangent_client_url.searchParams.get("resp_id");
}

function checkoutDataApiCall(tangent_response_id){
  if (tangent_response_id != null) {
    var checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id="+tangent_response_id+ "&self_serve=true" + "&multiple_variants=true";
    fetch(checkout_url)
    .then(data => {
      return data.json();
    })
    .then(response => {
      checkoutDataProcess(response);
      return response;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

function checkoutDataProcess(response){
    var tangent_recommended_products = response.products;
    tangent_client_domain_currency = document.querySelector("#tangent_client_currency").innerText; 

    // Setting Default variant price symbol
    if (tangent_client_domain_currency == "") {
        tangent_client_domain_currency = '$';
    }
   
    // Setting selfie / default image
    setTangentSelfieSection(response);
    var tangent_product_sections = response.product_sections;
    var tangent_text_sections = response.text_sections;
    
    if(tangent_product_sections!=undefined){
      createProductSection(response);
    }    

    if(response.text_sections!=undefined){
      createTextSection(tangent_product_sections,tangent_text_sections);
    }
    if (tangent_recommended_products.length > 0) {
        enableButtonListener();
        loadElementsOnResponseData();        
    }
    else {
        document.querySelector('#tangent-general-text').innerHTML = no_products_found_text;
    }
  
    setTabOpen(response.tags);

    if (response.description == '') {
        document.querySelector('#tangent-general-text').style.display = "block";
    }
}

function setTabOpen(tags){
  document.querySelector("#tab-wrapper").style.display="block";
  let tabs =  document.querySelectorAll(".tablinks");
  let tab_contents = document.querySelectorAll(".tabcontent");
  let tab_index=2;
  if(tags.includes('Simple_routine')){
    tab_index =1;
    enableSelfieSection('section_selfie_skin_essentials');
  }
  else{
    enableSelfieSection('section_selfie_skin_supercharged');
  }
  tabs[tab_index].classList.add("active");
  tab_contents[tab_index].style.display="block";
}

function enableSelfieSection(section){
  let all_selfie_containers = document.querySelectorAll('.tangent_selfie_parent_containers');
  for (container of all_selfie_containers) {
    container.classList.add('tangent-hide-section');
  }
  document.querySelector("#"+section+"_container_parent").classList.remove('tangent-hide-section');
}

// Updating add all to cart object for sections
function updateSectionAllToCartLink(section_name,product_id,variant_id){
  if(sections_add_to_cart_map[section_name]){
      if(!sections_add_to_cart_map[section_name].list.includes(variant_id)){
        sections_add_to_cart_map[section_name].count++;
        sections_add_to_cart_map[section_name].cart_link =  sections_add_to_cart_map[section_name].cart_link+ "&id[]=" + variant_id;
        sections_add_to_cart_map[section_name].list.push(variant_id);
      }
  }
  else{
      sections_add_to_cart_map[section_name] = {
          count:1,
          cart_link: tangent_client_domain_url + "/cart/add?id[]="+variant_id,
          list:[variant_id]
      }
  }
}

// Add all to cart function for sections
function addAllTocartFunction(section) {  
    if(sections_add_to_cart_map[section]!=undefined){
        document.getElementById(section+"_add_all_cart_link").setAttribute("href", sections_add_to_cart_map[section].cart_link);
    } 
    else {
        var x = document.querySelector("#message-text");
        x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
        x.className = "show";
        setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
    }
}

const getVariantImage = (imageId, product) => {
    var product_image;
    
    if(imageId!=null){
        var all_images = product.images;
        if(all_images!=undefined){
            for(var im=0;im<all_images.length;im++){
                if(imageId==all_images[im].id){
                    product_image = all_images[im].src;
                }
            }
        }
    }
    else{
        if(product.image!=null){
            product_image = product.image.src;
        }
        else{
            product_image = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
        }
    }

    if(product_image== undefined || product_image==null){
        product_image = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
    }
    return product_image;
}

// Add To Cart Function
function addToCart(btn){ 
  let formData = {
   'items': [{
    'id': btn.id,
    'quantity': 1
    }]
  };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
     if(btn!=undefined){
        if(btn.childNodes[0]!=undefined){
          btn.childNodes[0].innerHTML = default_addedToCartText;
          btn.childNodes[0].classList.add("added-to-cart-style");
        }
        else{
          btn.innerHTML = default_addedToCartText;
          btn.classList.add("added-to-cart-style"); 
        }
      }    
      document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
      document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
      })); 
      return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

// Toggle - selfie canvas 
function selfieCanvasDisplayToggle(display){
  document.querySelector("#selfie_canvas").style.display=display;  
}

// Main Section container 
function createSectionContainer(section_name){
    var section_container = document.createElement("div");
    section_container.id=section_name+"_container";
    section_container.classList.add("tabcontent");
    return section_container;
}

// Add to cart button for sections
function createSectionAddAllToCart(section_name) {
    var add_all_to_cart_p_tag = document.createElement("p");
    add_all_to_cart_p_tag.id = section_name+"_add_all_to_cart";
    add_all_to_cart_p_tag.classList.add("section_add_all_to_cart");
    add_all_to_cart_p_tag.classList.add(section_name+"_add_all_to_cart");

    var add_all_cart_link = document.createElement("a");
    add_all_cart_link.id = section_name+"_add_all_cart_link";
    add_all_cart_link.classList.add("section_add_all_cart_link");
    add_all_cart_link.classList.add(section_name+"_add_all_cart_link");
    add_all_cart_link.href="#";
    add_all_cart_link.innerHTML = default_add_all_to_cart_text;

    // Enabling listener
    add_all_cart_link.addEventListener(
        'click',
        function () { addAllTocartFunction(section_name); },
        false
    );
    add_all_to_cart_p_tag.appendChild(add_all_cart_link);
    return add_all_to_cart_p_tag;
}

function isSectionAddAllToCartNeeded(section_name){
  if(sections_add_to_cart_map[section_name]!=undefined && sections_add_to_cart_map[section_name].count>1){
    return true;
  }
  else{
    return false;
  }
}

// Container having individual products
function addSectionProductGridContainer(section_name, product_id_list, response) {
    var product_grid_view_container = document.createElement("div");
    product_grid_view_container.id = section_name+"_product_grid";
    product_grid_view_container.classList.add("section_product_grid");
    product_grid_view_container.classList.add(section_name+"_product_grid");
    product_grid_view_container = addProductsToGridContainer(product_grid_view_container, product_id_list, response, section_name);
    return product_grid_view_container;
}

function addProductsToGridContainer(container, id_list, response, section_name){
  id_list.forEach(function (id, index) {
    let product_html = getProductHTML(id, response, section_name);
    container.innerHTML = container.innerHTML + product_html;
  });
  return container;
}

function getProductHTML(product_id, response, section_name){
  let tangent_recommended_products = response.products;
  
  for (var index = 0; index < tangent_recommended_products.length; index++) {
    if(tangent_recommended_products[index].id==Number(product_id)){
      // By Default first variant is selected variant for the product
      var selected_variant = tangent_recommended_products[index].variants[0];
      
      // Setting default / first variant data
      var product_price = selected_variant.price;
      var variant_image_url = getVariantImage(selected_variant.image_id,tangent_recommended_products[index]);
      var variant_product_url = tangent_client_domain_url + '/products/';
      
      variant_product_url = variant_product_url + tangent_recommended_products[index].handle + "?variant=" + selected_variant.id;
      
      let cart_button = getCartButtonHTML(tangent_recommended_products[index], selected_variant, section_name,index);
      
      // Product View HTML
      let product_html = '<div><a id="url_tangent_product_' + index + '" class="tangent-text-link" target="_blank" href="' + variant_product_url + '"><img id="image_tangent_product_' + index + '" src="' + variant_image_url + '" class="tangent_product_image"><p class="tangent-product-title tangent_product_title_text"><b>' + tangent_recommended_products[index].title + '</b></p><p id="price_tangent_product_' + index + '" class="tangent_product_price_text">' + tangent_client_domain_currency + product_price + '</p></a><div id='+section_name+'_variant_'+index+'></div>'+cart_button+'<div/>';
      
      return product_html;
    }
  }
}

function getCartButtonHTML(product, variant, section_name, index){
  let cart_additional_class="";
  if(!isProductAvailable(product, variant)){
    default_addToCartText = out_of_stock_text;
    cart_additional_class = "disable-btn-wrapper";
  } 
  else{
    updateSectionAllToCartLink(section_name, product.id, variant.id);
  }
  let cart_button = '<a class="tangent-product-add-btn-wrapper '+cart_additional_class+'" id="'+variant.id+'" href="javascript: void(0)"><p class="tangent-btn-add tangent_add_to_cart_button" id="'+section_name+'_cart_tangent_product_' + index + '_text">' + default_addToCartText + '</p></a>';
  return cart_button;
}

function isProductAvailable(product, variant){
  // Check if Product is active
  if(product.status == "active" && variant.inventory_policy != "deny"){
    return true;
  }
  else{
    if(product.status != "active" || variant.inventory_policy == "deny" && variant.inventory_quantity<1 && variant.inventory_management!=null){
      return false;
    }
    else {
      return true;
    }
  }
}

// Custom function for scroll to operation
function scrollToElement(element_id){
  let element;  
  switch(element_id) {
    case "faq_section":
      element = document.getElementById('shopify-section-template--18155405869271__collapsible_content_8RpReG');
      break;
    case "expert_section":
      element = document.getElementById('shopify-section-template--18155405869271__image_with_text_LmYLBB');
      break;
    default:
      element = document.getElementById(element_id);
  }
  if(element!=undefined){
    element.scrollIntoView();
  }
}

// Tab buttons 
function createTabButton(section_name) {
    var tab_button = document.createElement("button");
    tab_button.id = section_name+"_tab_button";
    tab_button.innerHTML = getTabTitle(section_name);
    tab_button.name = section_name;
    tab_button.classList.add("tablinks");
    tab_button.addEventListener(
        'click',
        function () { switchTab(this); },
        false
    );
    tangent_custom_tabs.appendChild(tab_button);
}

function getTabTitle(section){
  var tab_title;
  if(tabs_title_mapping[section]!=undefined){
    tab_title = tabs_title_mapping[section];
  }
  else{
    tab_title = section.replace("section_","").replace("_"," ").toUpperCase();
  }
  return tab_title;
}

// Product Section Creation
function createProductSection(response){
  let product_sections = response.product_sections;
  let text_sections = response.text_sections;
    for (const section_name in product_sections) {
      // The created container will have both a container to show text and products
      var section_container = createSectionContainer(section_name);    
  
      // Creating text sections before products sections if exists
      if(text_sections!=undefined){
          createTextSectionBeforeProducts(text_sections,section_container,section_name);
      }    
      
      // Creating section to add all products
      section_container.appendChild(addSectionProductGridContainer(section_name,product_sections[section_name],response));

      
      if(isSectionAddAllToCartNeeded(section_name)){
        // Creating add all to cart button for the section    
        section_container.appendChild(createSectionAddAllToCart(section_name));
      }
      
      // Add to main container wrapper
      tangent_sections_wrapper_element.appendChild(section_container);
      createTabButton(section_name);
    }
}

// Text Sections with products sections
function createTextSectionBeforeProducts(text_sections,section_container, section_name){
    if(text_sections[section_name]!=undefined){
        var section_div = document.createElement("div");
        section_div.id = section_name+"_text_container";
        section_div.classList.add("section_text_container");
        section_div.classList.add(section_name+"_text_container");
        section_div.innerHTML = text_sections[section_name].join(' ');
        section_container.appendChild(section_div);
    }
}

// Section Text Creation (one without a product section)
function createTextSection(product_sections, text_sections){
    for (const section_name in text_sections) {
        // For removing duplicate entry
        if(product_sections[section_name]==undefined){
            var section_container = createSectionContainer(section_name);

            var section_div = document.createElement("div");
            section_div.id = section_name+"_text_container";
            section_div.classList.add("section_text_container");
            section_div.classList.add(section_name+"_text_container");
            section_div.innerHTML = text_sections[section_name].join(' ');
            section_container.appendChild(section_div);  

            // To Add to top of the page container
            if(section_name == "section_selfie"){
              var section_selfie = document.querySelector("#section_selfie_container_parent");
              section_container.classList.remove('tabcontent');   
              section_container.classList.add('tangent-selfie-containers');
              section_selfie.appendChild(section_container);
            }
            else if(section_name=="section_how_to_apply_basic"){
              var section_basic_container = document.querySelector("#section_basic_container");
              section_container.classList.remove('tabcontent');   
              section_basic_container.appendChild(section_container); 
            } 
            else if(section_name=="section_how_to_apply_skinsentials"){
              var section_skinsentials_container = document.querySelector("#section_skinsentials_container");
              section_container.classList.remove('tabcontent');   
              section_skinsentials_container.appendChild(section_container); 
            }
            else if(section_name=="section_how_to_apply_supercharged"){
              var section_supercharged_container = document.querySelector("#section_supercharged_container");
              section_container.classList.remove('tabcontent');   
              section_supercharged_container.appendChild(section_container); 
            }
            else if(section_name=="section_selfie_skin_essentials"){
              var section_selfie_essentials = document.querySelector("#section_selfie_skin_essentials_container_parent");
              section_container.classList.remove('tabcontent');   
              section_container.classList.add('tangent-selfie-containers');
              section_selfie_essentials.appendChild(section_container); 
            }
            else if(section_name=="section_selfie_skin_supercharged"){
              var section_selfie_supercharged = document.querySelector("#section_selfie_skin_supercharged_container_parent");
              section_container.classList.remove('tabcontent');   
              section_container.classList.add('tangent-selfie-containers');
              section_selfie_supercharged.appendChild(section_container); 
            }
            else{
              // Add to main container wrapper
              tangent_sections_wrapper_element.appendChild(section_container); 
            }   
        }
    }
}

// Setting Selfie / Default Image
function setTangentSelfieSection(response) {
    hideLoading();
  
    var selfie_image = document.querySelector("#tangent_selfie_image");
    if(response.selfie_html!=null && response.selfie_html!=undefined){
      document.getElementById("tangent_selfie_container").innerHTML = response.selfie_html;
    }
    else{
        if(response.selfie_url!=undefined && response.selfie_url!=null){
          selfie_image.style.display = "flex";
          document.querySelector('#tangent_selfie_image').src = response.selfie_url;
        }
        else{
            if(tangent_default_selfie_image_url!=""){
              selfie_image.style.display = "flex";
              if(response.tags.includes("oily_skin")){
                tangent_default_selfie_image_url = "https://cdn.shopify.com/s/files/1/0665/2405/3719/files/Coats_Skinsentials_BlemishDefence_Still_Life_Bathroom_2.jpg?v=1720525580";
              }
              selfie_image.src = tangent_default_selfie_image_url;
            }
            else{
                document.querySelector("#tangent_selfie_container").style.display = "none";
            }
        }
    }
}

// Handle Tab button selection
function switchTab(element) {
  let i, tabcontent, tablinks;
  // This is to clear the previous clicked content.
  tabcontent = document.querySelectorAll(".tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  
  tablinks = document.querySelectorAll(".tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  // Display the clicked tab and set it to active.
  document.getElementById(element.name+"_container").style.display = "flex";
  document.getElementById(element.name+"_tab_button").classList.add("active");
  if(element.name=="section_skinsentials"){
    enableSelfieSection('section_selfie_skin_essentials');
  }
  else if(element.name=="section_supercharged"){
    enableSelfieSection('section_selfie_skin_supercharged');
  }
  else{
    enableSelfieSection('section_selfie');
  }
}

// Enabling button listeners
function enableButtonListener(){
    // Listner for section add all to carts
    var all_btns = document.querySelectorAll('.tangent-product-add-btn-wrapper');
    for (var b = 0; b < all_btns.length; b++) {
        all_btns[b].addEventListener(
            'click',
            function () { addToCart(this); },
            false
        );
    }
}

function loadElementsOnResponseData(){
  var all_elements = document.querySelectorAll('.load-on-data');
  for (var ae = 0; ae < all_elements.length; ae++) {
      all_elements[ae].style.display="block";
  }
}

// Hide loading
function hideLoading(){
  document.querySelector("#loading-section").style.display = "none";
}
